module.exports = __webpack_public_path__ + "fe61189b878e003881194b27457a3a29.svg";